export default {
  router: state => state.router,
  routeLoading: state => state.routeLoading,
  isSuperUser: state => state.isSuperUser,
};
